import {
  faChartPieSimpleCircleDollar,
  faMinus,
} from '@fortawesome/pro-regular-svg-icons';
import { Zuschlag } from '../../entities';
import { Badge } from '@/components/ui/badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function ZuschlaegeCell({ zuschlaege }: { zuschlaege: Zuschlag[] }) {
  return (
    <Badge
      className={`px-2 py-1.5 space-x-2 h-8 w-[50px] bg-neutrals-200`}
      variant="secondary">
      <FontAwesomeIcon
        icon={faChartPieSimpleCircleDollar}
        className={
          zuschlaege.length > 0 ? 'text-primary-blue-600' : 'text-neutrals-600'
        }
        size="lg"
      />
      {zuschlaege.length > 0 ? (
        <span className="text-black font-bold">{zuschlaege.length}</span>
      ) : (
        <FontAwesomeIcon
          icon={faMinus}
          size="sm"
          className="text-neutrals-600 font-thin"
        />
      )}
    </Badge>
  );
}
